module.exports = __webpack_public_path__ + "static/media/SWSCRC1-23.f2156b05.mp3";